import {
  GET_ALLOTVEHICLE,
  GET_AVAILABLESUPPLIERS,
  GET_AVAILABLEVEHICLE,
  GET_CANCELCHARGES,
  GET_CANCELTRIP,
  GET_DISPATCHVEHICLE,
  ALLOT_TO_SUPPLIER,
  RE_ASSIGN_DRIVER,
} from "resources/actionTypes";

// export function allotVehicle(payloadData, page, payload) {
//   const data = {
//     trip: payloadData,
//     page: page,
//     payload: payload,
//   };

//   return {
//     type: GET_ALLOTVEHICLE.GET_ALLOTVEHICLE_REQUESTED,
//     payload: data,
//   };
// }
export function allotVehicle(payloadData, page, payload, onSuccess) {
  const data = {
    trip: payloadData,
    page: page,
    payload: payload,
    onSuccess: onSuccess,
  };

  return {
    type: GET_ALLOTVEHICLE.GET_ALLOTVEHICLE_REQUESTED,
    payload: data,
  };
}

export function allotToSupplier(payloadData, page, payload) {
  const data = {
    trip: payloadData,
    page: page,
    payload: payload,
  };

  return {
    type: ALLOT_TO_SUPPLIER.ALLOT_TO_SUPPLIER_REQUESTED,
    payload: data,
  };
}
export function getAvailableVehicle(payload) {
  return {
    type: GET_AVAILABLEVEHICLE.GET_AVAILABLEVEHICLE_REQUESTED,
    payload: payload,
  };
}

export function clearGetAvailableVehicle() {
  return {
    type: GET_AVAILABLEVEHICLE.GET_AVAILABLEVEHICLE_CLEAR,
  };
}

export function getAvailableSuplliers(payload) {
  return {
    type: GET_AVAILABLESUPPLIERS.GET_AVAILABLESUPPLIERS_REQUESTED,
    payload: payload,
  };
}

export function clearGetAvailableSuplliers() {
  return {
    type: GET_AVAILABLESUPPLIERS.GET_AVAILABLESUPPLIERS_CLEAR,
  };
}

// export function getDispatchDetails(payloadData, page, payload) {
//   const data = {
//     trip: payloadData,
//     page: page,
//     payload: payload,
//   };

//   return {
//     type: GET_DISPATCHVEHICLE.GET_DISPATCHVEHICLE_REQUESTED,
//     payload: data,
//   };
// }

export function getDispatchDetails(payloadData, page, payload, onSuccess) {
  const data = {
    trip: payloadData,
    page: page,
    payload: payload,
    onSuccess: onSuccess,
  };

  return {
    type: GET_DISPATCHVEHICLE.GET_DISPATCHVEHICLE_REQUESTED,
    payload: data,
  };
}

// export function cancelTrip(payloadData, page, payload) {
//   const data = {
//     trip: payloadData,
//     page: page,
//     reservationPayload: payload,
//   };

//   return {
//     type: GET_CANCELTRIP.GET_CANCELTRIP_REQUESTED,
//     payload: data,
//   };
// }

export function cancelTrip(payloadData, page, payload, onSuccess) {
  const data = {
    trip: payloadData,
    page: page,
    reservationPayload: payload,
    onSuccess: onSuccess,
  };

  return {
    type: GET_CANCELTRIP.GET_CANCELTRIP_REQUESTED,
    payload: data,
  };
}

export function getCancelCharges(id, setCancelCharges) {
  const payloadData = {
    id: id,
    setCancelCharges: setCancelCharges,
  };
  return {
    type: GET_CANCELCHARGES.GET_CANCELCHARGES_REQUESTED,
    payload: payloadData,
  };
}
export function reAssignDriver(reAssignData, pageType, payload, onSuccess) {
  return {
    type: RE_ASSIGN_DRIVER.RE_ASSIGN_DRIVER_REQUEST,
    payload: { reAssignData, pageType, payload, onSuccess },
  };
}
